
import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-[9999] overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      "break-words max-w-[200px]",
      className
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }

// Alias re-export to maintain backward compatibility with code that
// expects `TooltipTriggerWithChildren` from this module. The Radix
// `TooltipPrimitive.Trigger` already forwards its children, so the
// base `TooltipTrigger` defined above fulfils the same contract. We
// therefore simply export an alias rather than create a duplicate
// component implementation.

/**
 * @deprecated Use `TooltipTrigger` instead. This alias is provided so existing
 *             imports (`TooltipTriggerWithChildren`) continue to work without
 *             requiring code changes. It can be removed once all usages have
 *             been migrated.
 */
export const TooltipTriggerWithChildren = TooltipTrigger;
